export const BACKUP_STATUS_DELETE_RESET = 'BACKUP_STATUS_DELETE_RESET'
export const BACKUP_STATUS_DELETE_SET_ERROR = 'BACKUP_STATUS_DELETE_SET_ERROR'
export const BACKUP_STATUS_DELETE_SET_DELETED = 'BACKUP_STATUS_DELETE_SET_DELETED'
export const BACKUP_STATUS_DELETE_TOGGLE_LOADING = 'BACKUP_STATUS_DELETE_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/backup_status/delete/mutation_types.js